"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _dateInputs = require("@kyruus/date-inputs");
var _propTypes = require("prop-types");
var _validation = require("./validation");
var _styles = require("../../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const leftPad = num => num < 10 ? `0${num}` : num;

/**
 *
 * @param {Date} date
 * @returns {String} 2020-01-01
 */
const dateToDayStr = date => date ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(date.getDate())}` : '';
const isSameDay = (date1, date2) => dateToDayStr(date1) === dateToDayStr(date2);
const DOBInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    step,
    onChange,
    templateVariables
  } = _ref;
  const {
    question,
    control
  } = step;
  const validate = (0, _validation.getValidator)(control);
  const [errors, setErrors] = (0, _react.useState)([]);
  const localValue = (0, _react.useRef)('');
  const handleOnChange = (0, _react.useCallback)(data => {
    const value = data.date;
    const nextErrors = validate(data);
    const allFieldsEntered = data.year && data.month && data.day && data.year.length === 4;
    if (allFieldsEntered) {
      setErrors(nextErrors);
    }

    // NOTE:
    // we're storing/accessing local answer to avoid calling
    // `onChange` after onblur event
    if (isSameDay(localValue.current, value)) {
      return;
    }
    localValue.current = value;
    onChange({
      step,
      value: dateToDayStr(value),
      errors: nextErrors
    });
  }, [onChange, setErrors, validate, step]);
  return /*#__PURE__*/_react.default.createElement(_styles.ControlContainer, {
    "data-testid": "GxControl__DOB",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_styles.Question, {
    content: question,
    replacement: templateVariables
  }), /*#__PURE__*/_react.default.createElement(_dateInputs.SeparateNumericsDateInput, {
    label: control.label,
    required: control.isRequired,
    month: control.month,
    day: control.day,
    year: control.year,
    errors: errors,
    onChange: handleOnChange
  }));
});
DOBInput.displayName = 'DOBInput';
DOBInput.propTypes = {
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  onChange: _propTypes.func.isRequired,
  step: (0, _propTypes.shape)({
    id: _propTypes.number.isRequired,
    question: _propTypes.string.isRequired,
    control: (0, _propTypes.shape)({
      label: _propTypes.string.isRequired,
      isRequired: _propTypes.bool,
      invalidMsg: _propTypes.string,
      isRequiredMsg: _propTypes.string,
      month: (0, _propTypes.shape)({
        label: _propTypes.string,
        isRequiredMsg: _propTypes.string,
        invalidMsg: _propTypes.string,
        placeholder: _propTypes.string,
        autoComplete: _propTypes.string,
        ariaDescription: _propTypes.string,
        name: _propTypes.string
      }).isRequired,
      day: (0, _propTypes.shape)({
        label: _propTypes.string,
        isRequiredMsg: _propTypes.string,
        invalidMsg: _propTypes.string,
        placeholder: _propTypes.string,
        autoComplete: _propTypes.string,
        ariaDescription: _propTypes.string,
        name: _propTypes.string
      }).isRequired,
      year: (0, _propTypes.shape)({
        label: _propTypes.string,
        isRequiredMsg: _propTypes.string,
        invalidMsg: _propTypes.string,
        placeholder: _propTypes.string,
        autoComplete: _propTypes.string,
        ariaDescription: _propTypes.string,
        name: _propTypes.string
      }).isRequired
    }).isRequired
  }),
  templateVariables: _propTypes.object
};
var _default = exports.default = DOBInput;
DOBInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DOBInput",
  "props": {
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "step": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "number",
            "required": true
          },
          "question": {
            "name": "string",
            "required": true
          },
          "control": {
            "name": "shape",
            "value": {
              "label": {
                "name": "string",
                "required": true
              },
              "isRequired": {
                "name": "bool",
                "required": false
              },
              "invalidMsg": {
                "name": "string",
                "required": false
              },
              "isRequiredMsg": {
                "name": "string",
                "required": false
              },
              "month": {
                "name": "shape",
                "value": {
                  "label": {
                    "name": "string",
                    "required": false
                  },
                  "isRequiredMsg": {
                    "name": "string",
                    "required": false
                  },
                  "invalidMsg": {
                    "name": "string",
                    "required": false
                  },
                  "placeholder": {
                    "name": "string",
                    "required": false
                  },
                  "autoComplete": {
                    "name": "string",
                    "required": false
                  },
                  "ariaDescription": {
                    "name": "string",
                    "required": false
                  },
                  "name": {
                    "name": "string",
                    "required": false
                  }
                },
                "required": true
              },
              "day": {
                "name": "shape",
                "value": {
                  "label": {
                    "name": "string",
                    "required": false
                  },
                  "isRequiredMsg": {
                    "name": "string",
                    "required": false
                  },
                  "invalidMsg": {
                    "name": "string",
                    "required": false
                  },
                  "placeholder": {
                    "name": "string",
                    "required": false
                  },
                  "autoComplete": {
                    "name": "string",
                    "required": false
                  },
                  "ariaDescription": {
                    "name": "string",
                    "required": false
                  },
                  "name": {
                    "name": "string",
                    "required": false
                  }
                },
                "required": true
              },
              "year": {
                "name": "shape",
                "value": {
                  "label": {
                    "name": "string",
                    "required": false
                  },
                  "isRequiredMsg": {
                    "name": "string",
                    "required": false
                  },
                  "invalidMsg": {
                    "name": "string",
                    "required": false
                  },
                  "placeholder": {
                    "name": "string",
                    "required": false
                  },
                  "autoComplete": {
                    "name": "string",
                    "required": false
                  },
                  "ariaDescription": {
                    "name": "string",
                    "required": false
                  },
                  "name": {
                    "name": "string",
                    "required": false
                  }
                },
                "required": true
              }
            },
            "required": true
          }
        }
      },
      "required": false
    },
    "templateVariables": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};